/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    NAV
\*------------------------------------*/
class DisciplineNav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.dropdown = self.elem.querySelector('.js-discipline-nav-dropdown');
        self.trigger = self.elem.querySelector('.js-discipline-nav-more-button');
        self.breaks = [];
    }

    init() {
        let self = this;

        self.trigger.addEventListener('click', evt => {
            self.dropdown.classList.toggle('is-active');
            self.trigger.classList.toggle('is-active');
        });

        window.addEventListener('resize', evt => {
            self.updateNav();
        });

        self.updateNav();

        document.addEventListener('click', evt => {
            if (!self.elem.contains(evt.target)) {
                self.dropdown.classList.remove('is-active');
                self.trigger.classList.remove('is-active');
            }
        });
    }

    updateNav() {
        let self = this;

        let $nav = $(self.elem);
        let $btn = $nav.find('.js-discipline-nav-more-button');
        let $vlinks = $nav.find('.js-discipline-nav-visible-links');
        let $hlinks = $nav.find('.js-discipline-nav-dropdown');

        var availableSpace = $btn.hasClass('is-hidden') ? $nav.width() : $nav.width() - $btn.width() - 40;

        // The visible list is overflowing the nav
        if($vlinks.width() > availableSpace) {

            // Record the width of the list
            self.breaks.push($vlinks.width());

            // Move item to the hidden list
            $vlinks.children().last().prependTo($hlinks);

            // Show the dropdown btn
            if($btn.hasClass('is-hidden')) {
                $btn.removeClass('is-hidden');
            }

        // The visible list is not overflowing
        } else {

            // There is space for another item in the nav
            if(availableSpace > self.breaks[self.breaks.length-1]) {

                // Move the item to the visible list
                $hlinks.children().first().appendTo($vlinks);
                self.breaks.pop();
            }

            // Hide the dropdown btn if hidden list is empty
            if(self.breaks.length < 1) {
                $btn.addClass('is-hidden');
                $hlinks.addClass('is-hidden');
            }
        }

        // Keep counter updated
        $btn.attr("count", self.breaks.length);

        // Recur if the visible list is still overflowing the nav
        if($vlinks.width() > availableSpace) {
            self.updateNav();
        }
    }
}

export default DisciplineNav;
